import axios from 'axios';
import { API_CONFIG } from '../config/apiConfig';
import { getMsalInstance } from '../utils/msalInstance';
import { apiRequest } from '../authConfig';
import { handleAuthenticationError } from '../utils/authErrorHandler';

/**
 * Create axios instance with base configuration
 */
const apiClient = axios.create({
  baseURL: API_CONFIG.baseURL,
  timeout: API_CONFIG.timeout,
  headers: {
    ...API_CONFIG.headers,
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    'Pragma': 'no-cache',
    'Expires': '0',
  },
});

/**
 * Request interceptor to add MSAL authentication token
 */
apiClient.interceptors.request.use(
  async (config) => {
    console.log(`[API] ${config.method?.toUpperCase()} ${config.url}`);

    const msalInstance = getMsalInstance();
    const accounts = msalInstance.getAllAccounts();

    if (accounts.length > 0) {
      try {
        // Acquire token silently
        const response = await msalInstance.acquireTokenSilent({
          ...apiRequest,
          account: accounts[0],
        });

        // Add Authorization header
        if (config.headers) {
          config.headers.Authorization = `Bearer ${response.accessToken}`;
        }
      } catch (error) {
        console.error('[API] Failed to acquire token:', error);
      }
    }

    return config;
  },
  (error) => {
    console.error('[API] Request error:', error);
    return Promise.reject(error);
  }
);

/**
 * Response interceptor to handle errors globally
 */
apiClient.interceptors.response.use(
  (response) => {
    // Extract CorrelationId from response headers if available
    const correlationId = response.headers['x-correlation-id'];
    if (correlationId) {
      console.log(`[API] CorrelationId: ${correlationId}`);
    }
    return response;
  },
  async (error) => {
    if (error.response) {
      const status = error.response.status;
      console.error('[API] Response error:', status, error.response.data);

      // Trata erro 401 - Token expirado/invalido
      if (status === 401) {
        console.warn('[API] 401 Unauthorized - Redirecionando para login');
        await handleAuthenticationError();
        // Retorna promise que nunca resolve - pagina vai redirecionar
        return new Promise(() => {});
      }

      // 403 e tratado pelos componentes (PermissionContext)
    } else if (error.request) {
      // Request made but no response received
      console.error('[API] No response received:', error.request);
    } else {
      // Error setting up request
      console.error('[API] Request setup error:', error.message);
    }
    return Promise.reject(error);
  }
);

export default apiClient;
